import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { albumPath } from '@photos/shared'
import type { AlbumIndexEntry } from '@photos/shared'
import { fetchIndex } from '../lib/api'
import { mediaUrl } from '../lib/media'

/** Home page: the albums. Photos live inside them. */
export function Gallery(): JSX.Element {
  const [albums, setAlbums] = useState<AlbumIndexEntry[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    document.title = 'Photos'
    let cancelled = false
    fetchIndex()
      .then((index) => {
        if (!cancelled) setAlbums(index.albums)
      })
      .catch((err: Error) => {
        if (!cancelled) setError(err.message)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <main className="page">
      <header className="page__header">
        <h1>Photos</h1>
        <p className="muted">360° panoramas</p>
      </header>

      {error ? <p className="error">{error}</p> : null}
      {albums === null && !error ? <p className="muted">Loading…</p> : null}
      {albums?.length === 0 ? <p className="muted">Nothing published yet.</p> : null}

      <div className="grid">
        {albums?.map((album) => (
          <Link key={album.id} className="card" to={albumPath(album.id, album.slug)}>
            <div className="card__media">
              {album.coverUrl ? (
                <img className="card__thumb" src={mediaUrl(album.coverUrl)} alt="" loading="lazy" />
              ) : (
                // A published album with nothing in it yet still shows up, so it
                // needs something to stand in for the cover.
                <div className="card__thumb card__thumb--empty" />
              )}
            </div>
            <div className="card__body">
              <span className="card__title">{album.title}</span>
              <span className="card__meta">
                {album.photoCount} photo{album.photoCount === 1 ? '' : 's'}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </main>
  )
}
